import { BasicColumnTypes } from '@opengov/ogql-types';
import { EOgqlInfixColumnOperators } from '@opengov/reporting-types';

export enum EAllowedCalculationTypes {
  Currency = 'currency',
  Date = 'date',
  DayInterval = 'dayInterval',
  Numeric = 'numeric',
  Percent = 'percentage',
  YearInterval = 'yearInterval'
}

export enum ECalculationDateFormats {
  Year = 'year',
  YearMonth = 'yearMonth',
  YearMonthDay = 'yearMonthDay'
}

export enum ECalculationCustomValues {
  Numeric = 'custom_value_numeric',
  Percentage = 'custom_value_percentage',
  Year = 'custom_value_date_year',
  Month = 'custom_value_date_month',
  Day = 'custom_value_date_day'
}

export const CalculationCustomMessageKeys = {
  [ECalculationCustomValues.Numeric]: 'customValueNumeric',
  [ECalculationCustomValues.Percentage]: 'customValuePercentage',
  [ECalculationCustomValues.Year]: 'customValueDateYear',
  [ECalculationCustomValues.Month]: 'customValueDateMonth',
  [ECalculationCustomValues.Day]: 'customValueDateDay'
};

export const luxonDateFormats = {
  [ECalculationDateFormats.Year]: 'yyyy',
  [ECalculationDateFormats.YearMonth]: 'mm-yyyy',
  [ECalculationDateFormats.YearMonthDay]: 'yyyy-dd-mm'
};

export const CalculationColumnTypeSecondaryLabels = {
  [BasicColumnTypes.Numeric]: '#',
  [BasicColumnTypes.Percent]: '%',
  [BasicColumnTypes.Currency]: '$',
  [ECalculationDateFormats.Year]: 'YYYY',
  [ECalculationDateFormats.YearMonth]: 'MM-YYYY',
  [ECalculationDateFormats.YearMonthDay]: 'YYYY-MM-DD'
};

export const columnOutputTypes = {
  [BasicColumnTypes.Date]: BasicColumnTypes.Date,
  period: 'period',
  [BasicColumnTypes.Currency]: BasicColumnTypes.Currency,
  [BasicColumnTypes.Percent]: {
    [BasicColumnTypes.Percent]: BasicColumnTypes.Percent,
    [BasicColumnTypes.Numeric]: BasicColumnTypes.Numeric,
    [BasicColumnTypes.Currency]: BasicColumnTypes.Currency
  },
  [BasicColumnTypes.Numeric]: {
    [BasicColumnTypes.Numeric]: BasicColumnTypes.Numeric,
    [BasicColumnTypes.Currency]: BasicColumnTypes.Currency,
    [BasicColumnTypes.Percent]: BasicColumnTypes.Numeric,
    [BasicColumnTypes.Date]: BasicColumnTypes.Date
  }
};

export const columnOperatorAndCalculables = {
  [BasicColumnTypes.Date]: {
    [EOgqlInfixColumnOperators.add]: {
      types: [BasicColumnTypes.Numeric],
      custom: [ECalculationCustomValues.Day, ECalculationCustomValues.Month, ECalculationCustomValues.Year]
    },
    [EOgqlInfixColumnOperators.subtract]: {
      types: [BasicColumnTypes.Numeric, BasicColumnTypes.Date],
      custom: [ECalculationCustomValues.Day, ECalculationCustomValues.Month, ECalculationCustomValues.Year]
    }
  },
  [BasicColumnTypes.Year]: {
    [EOgqlInfixColumnOperators.add]: {
      types: [BasicColumnTypes.Numeric],
      custom: [ECalculationCustomValues.Year]
    },
    [EOgqlInfixColumnOperators.subtract]: {
      types: [BasicColumnTypes.Numeric, BasicColumnTypes.Year],
      custom: [ECalculationCustomValues.Year]
    }
  },
  [BasicColumnTypes.Currency]: {
    [EOgqlInfixColumnOperators.add]: {
      types: [BasicColumnTypes.Numeric, BasicColumnTypes.Currency],
      custom: [ECalculationCustomValues.Numeric]
    },
    [EOgqlInfixColumnOperators.subtract]: {
      types: [BasicColumnTypes.Numeric, BasicColumnTypes.Currency],
      custom: [ECalculationCustomValues.Numeric]
    },
    [EOgqlInfixColumnOperators.multiply]: {
      types: [BasicColumnTypes.Numeric, BasicColumnTypes.Currency, BasicColumnTypes.Percent],
      custom: [ECalculationCustomValues.Numeric, ECalculationCustomValues.Percentage]
    },
    [EOgqlInfixColumnOperators.divide]: {
      types: [BasicColumnTypes.Numeric, BasicColumnTypes.Currency, BasicColumnTypes.Percent],
      custom: [ECalculationCustomValues.Numeric, ECalculationCustomValues.Percentage]
    }
  },
  [BasicColumnTypes.Percent]: {
    [EOgqlInfixColumnOperators.add]: {
      types: [BasicColumnTypes.Percent],
      custom: [ECalculationCustomValues.Percentage]
    },
    [EOgqlInfixColumnOperators.subtract]: {
      types: [BasicColumnTypes.Percent],
      custom: [ECalculationCustomValues.Percentage]
    },
    [EOgqlInfixColumnOperators.multiply]: {
      types: [BasicColumnTypes.Numeric, BasicColumnTypes.Currency, BasicColumnTypes.Percent],
      custom: [ECalculationCustomValues.Numeric, ECalculationCustomValues.Percentage]
    },
    [EOgqlInfixColumnOperators.divide]: {
      types: [BasicColumnTypes.Numeric, BasicColumnTypes.Currency, BasicColumnTypes.Percent],
      custom: [ECalculationCustomValues.Numeric, ECalculationCustomValues.Percentage]
    }
  },
  [BasicColumnTypes.Numeric]: {
    [EOgqlInfixColumnOperators.add]: {
      types: [BasicColumnTypes.Numeric, BasicColumnTypes.Currency, BasicColumnTypes.Date],
      custom: [ECalculationCustomValues.Numeric]
    },
    [EOgqlInfixColumnOperators.subtract]: {
      types: [BasicColumnTypes.Numeric, BasicColumnTypes.Currency],
      custom: [ECalculationCustomValues.Numeric]
    },
    [EOgqlInfixColumnOperators.multiply]: {
      types: [BasicColumnTypes.Numeric, BasicColumnTypes.Currency, BasicColumnTypes.Percent],
      custom: [ECalculationCustomValues.Numeric, ECalculationCustomValues.Percentage]
    },
    [EOgqlInfixColumnOperators.divide]: {
      types: [BasicColumnTypes.Numeric, BasicColumnTypes.Currency, BasicColumnTypes.Percent],
      custom: [ECalculationCustomValues.Numeric, ECalculationCustomValues.Percentage]
    }
  },
  [BasicColumnTypes.DayInterval]: {
    [EOgqlInfixColumnOperators.add]: {
      types: [BasicColumnTypes.Numeric, BasicColumnTypes.DayInterval],
      custom: [ECalculationCustomValues.Numeric]
    },
    [EOgqlInfixColumnOperators.subtract]: {
      types: [BasicColumnTypes.Numeric, BasicColumnTypes.DayInterval],
      custom: [ECalculationCustomValues.Numeric]
    }
  },
  [BasicColumnTypes.YearInterval]: {
    [EOgqlInfixColumnOperators.add]: {
      types: [BasicColumnTypes.Numeric, BasicColumnTypes.YearInterval],
      custom: [ECalculationCustomValues.Numeric]
    },
    [EOgqlInfixColumnOperators.subtract]: {
      types: [BasicColumnTypes.Numeric, BasicColumnTypes.YearInterval],
      custom: [ECalculationCustomValues.Numeric]
    }
  }
};
